'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _feiseanna = require('../../../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeisAdjudicatorsController = function () {
  function FeisAdjudicatorsController(feis, fFeisService, fAdjudicatorService, $mdDialog, msgService) {
    _classCallCheck(this, FeisAdjudicatorsController);

    this.feis = feis;
    this._svcs = { feis: feis, fFeisService: fFeisService, fAdjudicatorService: fAdjudicatorService, $mdDialog: $mdDialog, msgService: msgService };
    this.adjNotAdded = [];
    this.searchText = '';
    this.getAdjudicators();
  }

  _createClass(FeisAdjudicatorsController, [{
    key: 'detach',
    value: function detach(adjudicator) {
      var _this = this;

      var dialog = this._svcs.$mdDialog.confirm().title('Are you sure?').textContent('This person will no longer be listed as a choice in Tabulations, but any scoresheets tied to her will remain.').ok('Delete');

      this._svcs.$mdDialog.show(dialog).then(function () {
        _this._svcs.fFeisService.detachAdjudicator(_this.feis.id, adjudicator.id).then(function () {
          _this.refresh();
          _this._svcs.msgService.displaySuccessMsg('Adjudicator ' + adjudicator.fname + ' ' + adjudicator.lname + ' was successfully removed.');
        }, function (err) {
          return _this._svcs.msgService.displayErrorMsg(err);
        });
      });
    }
  }, {
    key: 'getAdjudicators',
    value: function getAdjudicators() {
      var _this2 = this;

      return this._svcs.fFeisService.adjudicators().then(function (a) {
        _this2.all = a;
        _this2.refresh();
      }, function (err) {
        return _this2._svcs.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'attach',
    value: function attach(adjudicator) {
      var _this3 = this;

      if (!adjudicator) {
        return;
      }

      if (this.ours.some(function (a) {
        return a.id === adjudicator.id;
      })) {
        return;
      }

      return this._svcs.fFeisService.attachAdjudicator(this.feis.id, adjudicator.id).then(function () {
        _this3.refresh();
        _this3.searchText = '';
        _this3._svcs.msgService.displaySuccessMsg('Adjudicator ' + adjudicator.fname + ' ' + adjudicator.lname + ' was successfully added.');
      }, function (err) {
        return _this3._svcs.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      var _this4 = this;

      return this._svcs.fFeisService.adjudicators(this.feis.id).then(function (ours) {
        _this4.ours = ours;
        _this4.adjNotAdded = angular.copy(_this4.all);
        _this4.ours.forEach(function (attached) {
          _this4.adjNotAdded = _this4.adjNotAdded.filter(function (a) {
            return !(a.id === attached.id);
          });
        });
        _this4.toAdd = undefined;
      }, function (err) {
        return _this4._svcs.msgService.displayErrorMsg(err);
      });
    }
  }]);

  return FeisAdjudicatorsController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.adjudicators', ['ngMaterial', 'ui.router', 'ifeis.feiseanna', 'ifeis.router-history']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.adjudicators', {
    url: '/adjudicators',
    template: require('./tpl.html'),
    controller: FeisAdjudicatorsController,
    controllerAs: 'adjudicators',
    ncyBreadcrumb: {
      label: 'Adjudicators',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/adjudicators/index.js
// module id = 538
// module chunks = 0